var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXhv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14.889V.999h10.185v8.148L10.5 10.63V3.36H5.593v10.047L3 14.89zm10.093 8.1v7.964h-10V17.759l15.046-8.704V1h10.138v13.287L13.093 22.99zm7.5-12.36V3.407h5.046v9.306l-15.14 8.75v7.13H5.546v-9.167l15.047-8.796zM28.232 31V17.11l-2.593 1.483v10.046H20.73v-7.27l-2.686 1.482V31h10.186z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXhv);
export default __webpack_public_path__ + "static/media/XHV.8b1a3ef1e98c194df77fc57a089a36f3.svg";
export { ForwardRef as ReactComponent };